module.exports = __webpack_public_path__ + "static/media/Logo_Web.1cf2009e.png";